import { BatchAssignmentDialog } from "@/shared/components/domain/samples/batch-assignment-dialog";
import { ErrorAssignmentDialog } from "@/shared/components/domain/samples/error-assignment-dialog";
import { PersistenceStateUsingContext } from "@/shared/persistence-state/persistence-state-info";
import {
  ArtefactPage,
  ArtefactPageActions,
  ArtefactPageContent,
  ArtefactPageHeader,
  ArtefactPageNavigationOutlet,
} from "@/shared/service-manager/default-ui/artefact-page/artefact-page";
import { useParams } from "react-router";
import CreateCountingButton from "./_components/create-counting-button";
import { useShowDocumentationQuery } from "@/services/backend/documentations/service";
import PutBatchDialog from "@/routes/base-data/sample/batches/_components/put-batch-dialog";

export function DocumentationRoute() {
  const { processId, customerId, documentationId } = useParams();
  const { data: doc } = useShowDocumentationQuery({ id: documentationId! });
  const immutable = !!doc?.documentation.immutable;

  return (
    <ArtefactPage>
      <ArtefactPageHeader>
        <ArtefactPageActions className="flex w-full justify-between">
          <div className="flex w-full flex-row space-x-2">
            {!immutable && (
              <>
                <PutBatchDialog primary={false} />
                <BatchAssignmentDialog
                  ownerType="documentations.Documentation"
                  ownerId={documentationId!}
                />
                <ErrorAssignmentDialog
                  ownerType="documentations.Documentation"
                  ownerId={documentationId!}
                />
              </>
            )}
          </div>
          <PersistenceStateUsingContext className="mr-2" />
          {!immutable && (
            <CreateCountingButton
              processId={processId!}
              customerId={customerId!}
              documentationId={documentationId!}
            />
          )}
        </ArtefactPageActions>
      </ArtefactPageHeader>
      <ArtefactPageContent>
        <ArtefactPageNavigationOutlet />
      </ArtefactPageContent>
    </ArtefactPage>
  );
}
